import * as fromUser from '../actions/user.action';
import * as fromConfiguration from '../actions/configuration.action';
import * as fromStates from '../actions/states.action';
import * as fromFiscal from '../actions/fiscals.action';

export interface IKaitoriyaState {
    user: {
        loaded: boolean;
        loading: boolean;
        user: any;
    },
    configuration: {
        loaded: boolean;
        loading: boolean;
        configuration: any;
    },
    states: {
        loaded: boolean;
        loading: boolean;
        states: any[];
    },
    fiscals: {
        loaded: boolean;
        loading: boolean;
        fiscals: any[];
    },
}

export const initialState: IKaitoriyaState = {
    user: {
        loaded: false,
        loading: false,
        user: {}
    },
    configuration: {
        loaded: false,
        loading: false,
        configuration: {}
    },
    states: {
        loaded: false,
        loading: false,
        states: []
    },
    fiscals: {
        loaded: false,
        loading: false,
        fiscals: [],
    },
};


export function reducer(state: IKaitoriyaState = initialState, action: any): IKaitoriyaState {
    let target: any;
    switch (action.type) {
        case fromUser.ActionTypes.LOAD_USER:
            target = Object.assign({}, state.user, {loading: true});
            return Object.assign({}, state, {user: target});
        case fromUser.ActionTypes.LOAD_USER_SUCCESS:
            target = Object.assign({}, state.user, {
                loaded: true,
                loading: false,
                user: action.payload
            });
            return Object.assign({}, state, {user: target});
        case fromUser.ActionTypes.LOAD_USER_FAILURE:
            target = Object.assign({}, state.user, {
                loaded: true,
                loading: false,
                user: {}
            });
            return Object.assign({}, state, {user: target});
        case fromConfiguration.ActionTypes.LOAD_CONFIGURATION:
            target = Object.assign({}, state.configuration, {loading: true});
            return Object.assign({}, state, {configuration: target});
        case fromConfiguration.ActionTypes.LOAD_CONFIGURATION_SUCCESS:
            target = Object.assign({}, state.configuration, {
                loaded: true,
                loading: false,
                configuration: action.payload
            });
            return Object.assign({}, state, {configuration: target});
        case fromConfiguration.ActionTypes.LOAD_CONFIGURATION_FAILURE:
            target = Object.assign({}, state.configuration, {
                loaded: true,
                loading: false,
                configuration: {}
            });
            return Object.assign({}, state, {configuration: target});
        case fromStates.ActionTypes.LOAD_STATES:
            target = Object.assign({}, state.states, {loading: true});
            return Object.assign({}, state, {states: target});
        case fromStates.ActionTypes.LOAD_STATES_SUCCESS:
            target = Object.assign({}, state.states, {
                loaded: true,
                loading: false,
                states: action.payload
            });
            return Object.assign({}, state, {states: target});
        case fromStates.ActionTypes.LOAD_STATES_FAILURE:
            target = Object.assign({}, state.states, {
                loaded: true,
                loading: false,
                states: []
            });
            return Object.assign({}, state, {states: target});
        case fromFiscal.ActionTypes.LOAD_FISCALS:
            target = Object.assign({}, state.fiscals, {loading: true});
            return Object.assign({}, state, {fiscals: target});
        case fromFiscal.ActionTypes.LOAD_FISCALS_SUCCESS:
            target = Object.assign({}, state.fiscals, {
                loaded: true,
                loading: false,
                fiscals: action.payload
            });
            return Object.assign({}, state, {fiscals: target});
        case fromFiscal.ActionTypes.LOAD_FISCALS_FAILURE:
            target = Object.assign({}, state.fiscals, {
                loaded: true,
                loading: false,
                fiscals: []
            });
            return Object.assign({}, state, {fiscals: target});
        default:
            return state;
    }
}

export const getUser = (state: IKaitoriyaState) => state.user;
